// components/MyIcon.tsx
import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
  }


const HomeIcon: React.FC<IconProps> = ({className, ...props}) => {
    return (
        <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="20" 
        height="21" 
        viewBox="0 0 20 21" 
        fill="none"
        className={className}
        >
            <path 
                d="M1 10.8113L9.26523 2.54513C9.67139 2.1399 10.3286 2.1399 10.7338 2.54513L19 10.8113M3.07692 8.73436V18.0805C3.07692 18.6537 3.54215 19.119 4.11538 19.119H7.92308V14.619C7.92308 14.0457 8.38831 13.5805 8.96154 13.5805H11.0385C11.6117 13.5805 12.0769 14.0457 12.0769 14.619V19.119H15.8846C16.4578 19.119 16.9231 18.6537 16.9231 18.0805V8.73436M6.53846 19.119H14.1538" 
                stroke="currentColor" 
                strokeWidth="0.5" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
            />
        </svg>
    );
};

export default HomeIcon;
